<div
  *ngFor="let content of inputTemplate"
  class="theme-border mr-10 cursor-pointer"
  (click)="pageActions.clickOnTemplate(content)"
>
  {{ content }}
</div>
